import { useCatalogueMovieApi } from "../../../../common/api/catalogue-api/movie/useCatalogueMovieApi";
import { useSearchMasterApi } from "../../../../common/api/master-api/search/useSearchMasterApi";

export const useMovieAssetsApi = () => {
    const { getMovieById } = useCatalogueMovieApi();
    const { searchMovies } = useSearchMasterApi();

    return { getMovieById, searchMovies };
};
